import Service from "./Service"

class TaskService extends Service {

    findById = (id) => this.get(`/tasks/${id}`)

    search = (queryParams) => this.getWithParams("/tasks", queryParams)

    getUserTaskStats = () => this.getWithParams("/tasks/stats")

    getUnseenTaskCount = () => this.get("/tasks/unseen/count")

    getMarkedTaskCount = () => this.get("/tasks/marked/count")

    create = (request) => this.post("/tasks", request)

    update = (id, request) => this.patch(`/tasks/${id}`, request)

    setSeen = (id, seen) => this.patch(`/tasks/${id}/seen`, {seen})

    setMarked = (id, marked) => this.patch(`/tasks/${id}/marked`, {marked})

    setOwnPriority = (id, request) => this.patch(`/tasks/${id}/priority`, request)

    take = (id) => this.patch(`/tasks/${id}/take`)

    delete = (id) => this.del(`/tasks/${id}`)

    deleteFile = (id, fileId) => this.del(`/tasks/${id}/files/${fileId}`)
}

const taskService = new TaskService()
export default taskService